// @ts-nocheck
import * as actions from '../../action-types';
import * as types from '../../mutation-types';
import { map, pickBy, startsWith } from 'lodash-es';

let postCodes: undefined | Record<string, string>;

export default {
  [actions.FETCH_POSTAL_CODE_SUGGESTIONS]: async ({ commit }, searchTerm) => {
    if (!postCodes) {
      postCodes = await import('../postcode_map_light').then((module) => module.default);
    }
    const results = pickBy(postCodes, (value, key) => startsWith(key, searchTerm));
    const resultsArr = map(results, (value, key) => ({ office: value, code: key }));
    commit(types.SET_POSTAL_CODE_SUGGESTIONS, resultsArr);
  },
};
